module.exports = __webpack_public_path__ + "dist/img/phpto-pres-example.b45f878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/phpto-pres-example.jpg
// module id = 5XIc
// module chunks = 1